import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class ComplementsService { 

  constructor(
    private http: HttpClient,
    
  ) { }

  public url = GLOBAL.url; 
  private basePath = ENPOINT.url;


  obtenerComplementos(proveedor, fechaInicio, fechaFin, estatus, ordenCompra, noDocumento): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('desde', fechaInicio)
      .set('hasta', fechaFin)
      .set('estatus', estatus)
      .set('ordencompra', ordenCompra)
      .set('nodocumento', noDocumento)
    };
    return this.http.get(this.basePath + 'complementos/' + proveedor, options);
 }

 obtenerOrdenesPagadas(proveedor, fechaInicio, fechaFin, estatus, ordenCompra, noDocumento, idProveedor): Observable<any> {
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('desde', fechaInicio)
    .set('hasta', fechaFin)
    .set('estatus', estatus)
    .set('ordencompra', ordenCompra)
    .set('nodocumento', noDocumento)
  };
  return this.http.get(this.basePath + 'complementos/' + proveedor, options);
} 


postComplementos(data): Observable<any> {
  const body = data;
  const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
  const options = {
    headers: httpHeaders,
    withCredentials: true
      };
  return this.http.post(this.basePath + 'complementos', body, options);
}

/* */
obtenerFacturas(proveedor, fechai, fechaf): Observable<any> {
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('provedor', proveedor)
    .set('fechai', fechai)
    .set('fechaf', fechaf)
  };
  return this.http.get(this.basePath + 'complementos/facturas-pendientes', options);
 // return this.http.get(this.basePath + 'master-factura/obtener-facturas', options);
} 

getComplementos(proveedor, fechai, fechaf, estatus, noDocumento): Observable<any> {
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('desde', fechai)
    .set('hasta', fechaf)
    .set('estatus', estatus)
    .set('noDocPago', noDocumento)
  };
  return this.http.get(this.basePath + 'complementos/' + proveedor, options);
}

  getComplementosCargados(data): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(this.basePath + `complementos/reporte?desde=${ data.desde }&hasta=${ data.hasta }&proveedor=${ data.proveedor }&uuid-complemento=${ data.uuidComplemento }&folio-factura=${ data.folioFactura }`, options);
  }

  getDocsRelacionados(uuid): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };

    return this.http.get(this.basePath + `complementos/doc-relacionados/${uuid}`, options);
  }

  downloadZip(data): Observable<any> {
    const body = JSON.stringify(data);
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
    };
    return this.http.post(this.basePath + 'complementos/obtener-zip', body, options);
  }

  downloadXml(base64Route: string) {
    const params = new HttpParams()
      .set('ruta', base64Route);

    return this.http.get(`${this.basePath}master-factura/obtener-xml`, { 
      responseType: 'blob',
      params 
    });
  }

 downloadPdf(base64Route: string) {
    const params = new HttpParams()
      .set('ruta', base64Route);

    return this.http.get(`${this.basePath}master-factura/obtener-pdf`, { 
      responseType: 'blob',
      params 
    });
  }

  // downloadComplementXml(base64Route: string) {
  //   const params = new HttpParams()
  //     .set('ruta', base64Route);

  //   return this.http.get(`${this.basePath}complementos/obtener-xml`, { 
  //     responseType: 'blob',
  //     params 
  //   });
  // }

  // downloadComplementPdf(base64Route: string) {
  //   const params = new HttpParams()
  //     .set('ruta', base64Route);

  //   return this.http.get(`${this.basePath}complementos/obtener-pdf`, { 
  //     responseType: 'blob',
  //     params 
  //   });
  // }

  downloadExcelReport(params): Observable<any> {
    return this.http.get(`${this.basePath}complementos/reporte-xls${params}`, { 
      responseType: 'blob' 
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/complements/complements.service.ts